import { connect } from 'react-redux';
import { loadCareGuidesMembersPartnership } from '../../../../../state/modules/careGuidesMembersPartnership/actions';

import CareGuidesMembersPartnership from '../components/CareGuidesMembersPartnership';

const mapStateToProps = (state, ownProps) => {
  return {
    total: state.careGuidesMembersPartnership.get('total'),
    isLoading: state.careGuidesMembersPartnership.get('isLoading'),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    load: (partnershipId, page, limit, cb) => {
      dispatch(
        loadCareGuidesMembersPartnership(partnershipId, page, limit, cb)
      );
    },
  };
};

const CareGuidesMembersPartnershipContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(CareGuidesMembersPartnership);

export default CareGuidesMembersPartnershipContainer;
